import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { ExtensionType, extensions } from '@pixi/core';
var imageFormats = ["png", "jpg", "jpeg"];
var detectDefaults = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: -1
  },
  test: function test() {
    return Promise.resolve(true);
  },
  add: function () {
    var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formats) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", [].concat(_toConsumableArray(formats), imageFormats));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function add(_x) {
      return _add.apply(this, arguments);
    }
    return add;
  }(),
  remove: function () {
    var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formats) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", formats.filter(function (f) {
              return !imageFormats.includes(f);
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function remove(_x2) {
      return _remove.apply(this, arguments);
    }
    return remove;
  }()
};
extensions.add(detectDefaults);
export { detectDefaults };